// ShellSurfaces — the shell-level overlays mounted inside HubShell (Epic 4).
//
// One place that renders the inbox drawer, the timer widget and global search, so
// HubShell stays a thin layout. Also wires the global `/` keybinding that opens
// search from anywhere in the shell — the same gesture everywhere
// (00_CONTRACT.md §12). `/` is ignored when the person is already typing in an
// input/textarea/select/contenteditable, or when a meta key is held.

import React, { useEffect } from 'react';
import { useShellSurface } from '../../../contexts/ShellSurfaceContext';
import InboxDrawer from './InboxDrawer';
import TimerWidget from './TimerWidget';
import SearchOverlay from './SearchOverlay';

const isTypingTarget = (el) => {
  if (!el) return false;
  const tag = el.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (typeof el.isContentEditable === 'boolean' && el.isContentEditable) return true;
  return false;
};

export default function ShellSurfaces() {
  const { openSearch } = useShellSurface();

  // Global `/` → open search (ignored while typing or with a meta key).
  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== '/') return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (isTypingTarget(e.target)) return;
      e.preventDefault();
      openSearch();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [openSearch]);

  return (
    <>
      <InboxDrawer />
      <TimerWidget />
      <SearchOverlay />
    </>
  );
}
